import { ApolloError, useQuery } from "@apollo/client";
import { orderBy } from "lodash";
import { GET_SCHEDULES } from "graphql/queries";
import { ScheduleDoc, Schedules } from "types";

export function useSchedules(projectId: string | undefined): [ScheduleDoc[], boolean, ApolloError | undefined] {
    const { data, loading, error, refetch } = useQuery<Schedules>(GET_SCHEDULES, {
        variables: { projectId },
        errorPolicy: "all",
        skip: !projectId
    });

    return [data ? orderBy(data.schedules, (s: ScheduleDoc) => s.schedule.schedName) : [], loading, error];
}
